import { render } from "./SelectionView.vue?vue&type=template&id=bf045616&scoped=true"
import script from "./SelectionView.vue?vue&type=script&lang=js"
export * from "./SelectionView.vue?vue&type=script&lang=js"

import "./SelectionView.vue?vue&type=style&index=0&id=bf045616&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bf045616"]])

export default __exports__